import React from "react";
import { connect } from "react-redux";
import { saveAs } from "file-saver";

const ComplianceDownload = ({ documents, sasToken }) => {
  const documentsList = {
    passportOrBirthCertificate: {
      label: "Passport or Birth Certificate",
    },
    proofOfNationalInsurance: {
      label: "Proof of National Insurance",
    },
    headAndShoulderPhoto: {
      label: "Head and shoulders photo (To compare with Passport)",
    },
    idOrBiometricFront: {
      label: "EU ID Card or Biometric Card Front",
    },
    idOrBiometricBack: {
      label: "EU ID Card or Biometric Card Back",
    },
    additionalCertificate: {
      label: "Additional Certs or Tickets (FLT, VNA, Reach Etc.)",
    },
    bankDetails: {
      label: "Proof of Bank Details (Bank card or statement)",
    },
    proofOfAddress: {
      label: "Proof of Address",
    },
    universityEnrollmentLetter: {
      label: "University Enrollment Letter",
    },
    universityTermVacationDate: {
      label: "University Term/Vacation Dates",
    },
  };
  // Filter out the fields that aren't actual document objects
  const documentKeys = Object.keys(documentsList).filter(
    (key) => typeof documentsList[key] === "object"
  );

  return (
    <div className="container mt-2">
      <h2>Uploaded Proofs</h2>
      <ul className="list-group">
        {documentKeys?.map((key) => (
          <li
            key={key}
            className="list-group-item d-flex justify-content-between align-items-center"
          >
            {documentsList[key]?.label}
            {documents[key]?.url ? (
              <button
                onClick={() => {
                  const fileUrlWithSas = `${documents[key]?.url}?${sasToken}`;
                  const fileName = documents[key].name;

                  // Fetch the file with the appended SAS token
                  fetch(fileUrlWithSas)
                    .then((response) => {
                      if (!response.ok) {
                        throw new Error("Network response was not ok");
                      }
                      return response.blob(); // Convert response to blob
                    })
                    .then((blob) => {
                      saveAs(blob, fileName); // Download the file using file-saver
                    })
                    .catch((error) => {
                      console.error(
                        "Error downloading file with SAS token:",
                        error
                      );
                    });
                }}
                className="btn btn-primary text-white"
              >
                Download
              </button>
            ) : (
              <button disabled className="btn btn-dark text-white btn-disabled">
                {" "}
                Not Available
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(ComplianceDownload);
